import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { of, switchMap } from 'rxjs';
import { PICFLOW_STORYBLOK } from '../picflow-storyblok';
import { ProductService } from '../services/product.service';

export const storyblokProductsResolver: ResolveFn<unknown> = route => {
  const storyblokService = inject(PICFLOW_STORYBLOK);
  const productService = inject(ProductService);

  return storyblokService.getUniqueComponentsList(route).pipe(
    switchMap(components => {
      if (
        components.has('pricing_box_list') ||
        components.has('product_comparison_list') ||
        components.has('hero_pricing')
      ) {
        return productService.getAllListedProducts();
      }
      return of(undefined);
    })
  );
};
